import {
    RaikoGridOneColumn,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useState} from "react";
import {TourismService} from "../../serverService/tourism/TourismService";
import RaikoBaseDialogContentContainer
    from "../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";

export default function TourismAddNew({handleCloseDialog, handleAddNewPlace}) {

    const [title, setTitle] = useState("")
    const service = new TourismService()
    const [loading, setLoading] = useState(false)

    function handleCreatePlace() {
        setLoading(true)
        service.addNewPlace(title)
            .then(response => {
                handleCloseDialog()
                handleAddNewPlace(response)
                showSuccessMessage("مکان جدید با موفقیت ایجاد شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLoading(false)
        })
    }

    return <RaikoBaseDialogContentContainer
    >
        <RaikoSectionContainer
            title={"افزودن مکان جدید"}
            actionButtonTitle={"افزودن"}
            hasActionButton
            actionButtonOnclickWithValidation={handleCreatePlace}
            actionButtonLoadingState={loading}
            hasSecondaryButton
            secondaryButtonTitle={"بازگشت"}
            secondaryButtonOnClick={handleCloseDialog}
        >
            <RaikoSimpleInputOutlined
                labelText={"عنوان مکان"}
                value={title}
                setValue={setTitle}
                required
            />
        </RaikoSectionContainer>
    </RaikoBaseDialogContentContainer>

}